import axios from "axios"
import { Block, BlockType, ReviewGradeType } from "shared/types/science35Types"
import { Review, ReviewGroup } from "shared/types/teacherTypes"

/** Review Routes */

export async function getReviews({ excludeGroupedReviews } : { excludeGroupedReviews: boolean }): Promise<Review[]> {
    const res = await axios.get("/api/review/reviews", { params: { excludeGroupedReviews } })
    return res.data as Review[]
}

export async function createReview(groupIds?: string[]): Promise<string> {
    const res = await axios.post("/api/editing/reviews", { groupIds })
    return res.data as string
}

export async function updateReview(data: { reviewId: string, groupIds?: string[], title?: string, pretestId?: string, postTestId?: string, lessonId?: string, grade3pretestId?: string, grade3postTestId?: string,grade3lessonId?: string, image?: string }): Promise<string> {
    const res = await axios.put("/api/editing/reviews", data)
    return res.data as string
}

export async function deleteReview(reviewId: string): Promise<string> {
    const res = await axios.delete("/api/editing/reviews", { data: { reviewId } })
    return res.data as string
}

/** Block Routes */

export async function getBlocks(): Promise<Block[]> {
    const res = await axios.get("/api/editing/review-blocks")
    return res.data as Block[]
}

export async function getBlock(blockId: string): Promise<Block> {
    const res = await axios.get("/api/editing/review-blocks", { params: { blockId } })
    return res.data
}

export async function createBlock(): Promise<string> {
    const res = await axios.post("/api/editing/review-blocks")
    return res.data
}

export async function updateBlock({ blockId, block } : { blockId: string, block: string }): Promise<string> {
    const res = await axios.put("/api/editing/review-blocks", { blockId, block })
    return res.data as string
}

export async function deleteBlock(blockId: string): Promise<string> {
    const res = await axios.delete("/api/editing/review-blocks", { data: { blockId } })
    return res.data as string
}

/** Review Group Routes */

export async function getReviewGroup(groupId: string): Promise<ReviewGroup> {
    const res = await axios.get(`/api/review/review-groups/${groupId}`)
    return res.data as ReviewGroup
}

export async function getReviewGroups({ applyFilter, classId, gradeLevels, classGradeLevel, targetBlock }: { applyFilter: boolean, classId?: string, gradeLevels?: ReviewGradeType[], classGradeLevel?: string, targetBlock?: BlockType }): Promise<ReviewGroup[]> {
    const res = await axios.get("/api/review/review-groups", { params: { applyFilter, classId, gradeLevels, classGradeLevel, targetBlock } })
    return res.data as ReviewGroup[]
}

export async function createReviewGroup({ blockId } : { blockId?: string }): Promise<string> {
    const res = await axios.post("/api/editing/review-groups", { blockId })
    return res.data as string
}

export async function updateReviewGroup(data: { groupId: string, name: string, description: string, blocks: string[] }): Promise<string> {
    const res = await axios.put("/api/editing/review-groups", data)
    return res.data as string
}

export async function deleteReviewGroup(groupId: string): Promise<string> {
    const res = await axios.delete("/api/editing/review-groups", { data: { groupId } })
    return res.data as string
}
